<template>
  <div class="page-container appstore_wrap" style="background: #fff">
    <store-header
tabs="storeindex"
:marketInfo="marketInfo"
:marketClosed="marketClosed"
:isActive="true"
      :hasError="false"
@handleSearchApp="queryChange"
:home="true"
:type="type"></store-header>
    <!-- 间距 -->
    <div style="height: 70px"></div>
    <!-- 主体区域 -->
    <div v-if="!marketClosed" class="appstore_main">
      <div class="container_main">
        <!-- 左侧的筛选 -->
        <div class="left_box" width="240px">
          <div class="category">
            <!-- 产品分类菜单 -->
            <div class="product_kind_menu" v-loading="productLoading" v-if="categoryList.length > 0">
              <span slot="title" class="product_one_side">
                <span class="product_one_title">产品分类</span>
              </span>

              <el-menu
mode="vertical"
@open="handleOpen"
@close="handleClose"
:collapse-transition="true"
                :unique-opened="true"
active-text-color="#ffd04b">
                <el-submenu
v-for="(item, index) in categoryList"
:index="item.appClassificationID"
                  :key="item.appClassificationID"
:class="{ product_submenu: item.appClassificationID === subMenuColor }"
                  @titleClick="handleChangeCategory(item, 'sub', index)">
                  <template slot="title">
                    <div class="product_two_side">
                      <div class="product_two_title">
                        {{ item.appClassificationName }}（{{ item.appCount }}）
                      </div>
                    </div>
                  </template>
                  <div
                    :class="{
                      activeItem: subItem.appClassificationID === appType,
                      menuItem: true,
                    }"
                    v-for="subItem in item.children"
:key="subItem.appClassificationID"
                    @click="handleChangeCategory(subItem, 'item')"
                  >
                    <div class="product_three_side">
                      <div>{{ subItem.appClassificationName }}</div>
                    </div>
                  </div>
                </el-submenu>
              </el-menu>
            </div>
            <!-- 模版类型 -->
            <div class="tag_kind_menu" style="margin-top: 30px" v-loading="tagLoading" v-if="optionsAppType.length > 0">
              <div class="tag_one_title" style="margin-bottom:20px">包类型</div>
              <a-checkbox-group
v-model="value3"
name="checkboxgroup"
:options="optionsAppType"
                @change="changeAppTypeValue"
id="checkbox_style" />
            </div>
            <!-- 架构分类 -->
            <div class="tag_kind_menu" style="margin-top: 30px" v-loading="tagLoading" v-if="optionsCpu.length > 0">
              <div class="tag_one_title" style="margin-bottom:20px">架构分类</div>
              <a-checkbox-group
v-model="value2"
name="checkboxgroup"
:options="optionsCpu"
@change="handleCpuArchType"
                id="checkbox_style" />
            </div>
            <!-- 按标签分类 -->
            <div class="tag_kind_menu" style="margin-top: 30px" v-loading="tagLoading" v-if="tagsList.length > 0">
              <div class="tag_one_title" style="margin-bottom:20px">标签分类</div>
              <a-checkbox-group
v-model="value1"
name="checkboxgroup"
:options="tagsList"
@change="handleChangeTag"
                id="checkbox_style" />
            </div>
          </div>
        </div>
        <!-- 右侧应用列表 -->
        <div class="app_list_main">
          <!-- 列表排序 -->
          <div class="sort_title">
            <div class="app_sort">
              <div class="sort_list">
                <span class="sort_title_text">排序:</span>
                <span class="sort_item">
                 <!-- element ui 下拉框  -->
                  <el-select v-model="sortType" placeholder="请选择" @change="handleSortChange">
                    <el-option
                      v-for="item in sortList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </span>
                <div class="sort_type">
                  <span class="sort_title_text">排列方式:</span>
                  <div @click="handleChangeType('one')">
                    <img :src="sortType1" onload="SVGInject(this)" class="typeSvg" ref="typeOne" />
                  </div>
                  <div @click="handleChangeType('three')">
                    <img :src="sortType2" onload="SVGInject(this)" class="typeSvg" ref="typeThree" />
                  </div>
                </div>
              </div>
              <div class="app_total" v-if="pageTotal">
                共
                <span style="font-size: 18px; font-weight: 700;">{{ pageTotal }}</span>
                条
              </div>
            </div>
          </div>
          <!-- 应用列表 -->
          <div class="app_box" v-loading="appLoading">
            <!-- 一行展示一条数据 -->
            <template v-if="appList.length && !sortTypeStatus">
              <RowCard
                :appList="appList"
                :viewAppDetail="viewAppDetail"
                :timmer="timmer"
              />
            </template>
            <!-- 一行展示3条数据 -->
            <template v-if="appList.length && sortTypeStatus">
              <Card
                :appList="appList"
                :viewAppDetail="viewAppDetail"
                :timmer="timmer"
              />
            </template>
            <!-- 无数据 -->
            <template v-if="appList.length === 0 && !appLoading">
              <no-data class="noData" size="180px" />
            </template>
          </div>
          <!-- 分页 -->
          <el-pagination
v-if="pageTotal > 24"
class="app_pagination"
layout="prev, pager, next"
:page-size="pageSize"
            :total="pageTotal"
@current-change="changePage"></el-pagination>
        </div>
      </div>
    </div>
    <el-alert class="CloseMarket" v-if="marketClosed" title="该商店已经关闭，请稍后访问" type="warning" center show-icon></el-alert>
    <app-footer :isTheme="isTheme"></app-footer>
    <div class="backtop">
       <el-popover placement="left" trigger="hover">
          <img class="wechart" :src="marketInfo && marketInfo.banners && marketInfo.banners.length > 0 && marketInfo.banners[0].imageURL" alt="" />
          <p style="font-size: 12px; margin-bottom: 0px; margin-top:6px; text-align: center">扫一扫，邀你进群交流吧</p>
          <div slot="reference">
            <img src="../../assets/images/feedback.svg" alt="">
          </div>
        </el-popover>
    </div>
    <el-backtop style="right: 14px"></el-backtop>
  </div>
</template>
<script>
import { postAccessInfo } from '@/api/accessInfo';
import {
  getAppListApi,
  getCategoryListApi,
  getMarketBaseInfoApi,
  getHotAppListApi,
  getTagsListApi
} from '@/api/appStore';
import appInstall from '@/assets/images/app_install.svg';
import appVisit from '@/assets/images/app_visit.svg';
import bgImg from '@/assets/images/bg.jpg';
import productSvg from '@/assets/images/product_kind.svg';
import sortType2 from '@/assets/images/sort-type-one.svg';
import sortType1 from '@/assets/images/sort-type-three.svg';
import tagImg from '@/assets/images/tag.svg';
import tagSvg from '@/assets/images/tag_kind_icon.svg';
import { setWebInfo } from '@/utils/common';
import Card from '@/components/AppCard/card';
import RowCard from '@/components/AppCard/rowCard';
import { fetchdayTimes } from '@/utils/timmer';
import moment from 'moment';
import SVGInject from '@iconfu/svg-inject';
import { errorHandle } from '../../utils/error';
export default {
  name: 'AppStore',
  data() {
    return {
      isTheme: true,
      bgImg,
      tagImg,
      appInstall,
      appVisit,
      sortType1,
      sortType2,
      productSvg,
      tagSvg,
      SVGInject,
      appLogoDef: require('../../assets/images/app_icon.png'),
      marketId: '',
      marketInfo: {},
      page: 1,
      pageSize: 24,
      curTagList: [],
      appType: '',
      appList: [],
      pageTotal: '',
      categoryList: [],
      tagsList: [],
      searchQuery: '',
      marketClosed: false,
      appLoading: true,
      productLoading: true,
      tagLoading: true,
      arrowTimerConfig: true, // 排序时间箭头的状态,
      arrowUsedConfig: true, // 排序使用量箭头的状态
      indexConfig: '',
      openKeys: ['sub1'],
      openKeysTag: ['sub2'],
      sortTypeStatus: true, // 应用列表的排序方式
      subMenuColor: '',
      selectKeys: [],
      type: 'list',
      hotAppList: [],
      hotLoading: true,
      optionsCpu: ['arm64', 'amd64'],
      optionsAppType: [
        { label: 'Helm Chart', value: 'helm' },
        { label: 'Docker', value: 'docker' },
        { label: 'Rainbond App Model', value: 'RAM' },
        { label: '软件包', value: 'file' }
      ],
      cpuValue: '',
      archType: [],
      HistoricalInfo: {
        tag: [],
        temp: [],
        sort: { item: '', type: '', subMenuColor: '' },
        arch: []
      },
      sortList: [
        { label: '按创建时间', value: 'createTime' },
        { label: '按使用量', value: 'usedCount' },
        { label: '按更新时间', value: 'updateTime' }
      ],
      sortType: 'createTime',
      checkedamd64: false,
      checkedarm64: false,
      value1: [],
      value2: [],
      value3: []
    };
  },
  components: {
    Card,
    RowCard
  },
  computed: {
    defaultMarketDomain() {
      return this.$store.state.user.platformInfo.defaultMarketDomain;
    }
  },
  watch: {
    // 按时间排序
    arrowTimerConfig: function(newVal, oldVal) {
      if (this.indexConfig === 0) {
        if (newVal) {
          this.getAppList(0);
        } else {
          this.getAppList(0, '0');
        }
      }
    },
    // 按使用量排序
    arrowUsedConfig: function(newVal, oldVal) {
      if (this.indexConfig === 1) {
        if (newVal) {
          this.getAppList(1);
        } else {
          this.getAppList(1, false, '0');
        }
      }
    }
  },
  created() {
    const initTags = this.$route.query.tags;
    if (initTags) {
      this.value1.push(initTags);
    }
    // this.marketId = this.$route.params.marketID;
    this.marketId = this.$route.params.marketID || '859a51f9bb3b48b5bfd222e3bef56425';
    const queryName = this.$route.query.queryName;
    this.searchQuery = queryName;
    this.getStoreInfo();
    // 详情页跳转
    const queryFromDetail = this.$route.params;
    if (queryFromDetail && queryFromDetail.type === 'child') {
      // 三级菜单
      const parentId = queryFromDetail.parentId;
      this.handleChangeCategory(
        {
          appClassificationID: queryFromDetail.childId
        },
        'item'
      );
      this.openKeys = ['sub1', parentId];
    } else if (queryFromDetail && queryFromDetail.type === 'parent') {
      // 二级菜单
      this.handleChangeCategory({
        appClassificationID: queryFromDetail.parentId
      });
    }
  },

  mounted() {
    // 页面加载的处理
    const that = this;
    const appSorts = document.getElementsByClassName('sort_item');
    const sortType = document.getElementsByClassName('typeSvg');
    sortType[0].classList.add('activeType');
    for (let i = 0; i < appSorts.length; i++) {
      // eslint-disable-next-line space-before-function-paren
      appSorts[i].onclick = function () {
        that.indexConfig = i;
        for (let j = 0; j < appSorts.length; j++) {
          appSorts[j].classList.remove('active');
        }
        if (i === 0) {
          that.arrowTimerConfig = !that.arrowTimerConfig;
        } else {
          that.arrowUsedConfig = !that.arrowUsedConfig;
        }
        this.classList.add('active');
      };
    }
    const {
      params: { searchQuery }
    } = this.$route;
    if (searchQuery) {
      this.queryChange(searchQuery, 'detail');
    } else {
      setTimeout(() => {
        this.historicalRecordApp();
      }, 10)
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      this.appType = ''
      this.subMenuColor = key
      this.searchQuery = ''
      this.type = ''
      this.getAppList();

    },
    handleClose(key, keyPath) {
      this.subMenuColor = ''
      this.appType = ''
      this.searchQuery = ''
      this.type = ''
      this.getAppList();
    },
    historicalRecordApp() {
      const info = JSON.parse(window.sessionStorage.getItem('history'))
      if (info) {
        for (const key in info) {
          if (info.hasOwnProperty(key)) {
            const value = info[key];
            if (key === 'sort') {
              const { item, type, subMenuColor } = value
              if (item == '' && subMenuColor != '') {
                this.handleOpen(subMenuColor)
                this.subMenuColor = subMenuColor
              } else if (item != '' && subMenuColor == '') {
                this.handleChangeCategory(item, type)
                this.HistoricalInfo.sort.item = item
                this.HistoricalInfo.sort.type = type
              } else if (item != '' && subMenuColor != '') {
                this.handleOpen(subMenuColor)
                this.handleChangeCategory(item, type)
                this.HistoricalInfo.sort.item = item
                this.HistoricalInfo.sort.type = type
                this.subMenuColor = subMenuColor
              }
            }
            if (key === 'temp') {
              this.value3 = value
            }
            if (key === 'arch') {
              this.value2 = value
            }
            if (key === 'tag') {
              this.value1 = value
            }
          }
        }
        window.sessionStorage.removeItem('history')
      }
    },
    // 获取热门app列表
    getHotAppList() {
      this.hotLoading = true;
      getHotAppListApi({
        marketId: this.marketId,
        page: 1,
        pageSize: 8
      })
        .then((res) => {
          res && (this.hotAppList = res.apps);
          this.hotLoading = false;
        })
        .catch(() => {
          this.hotLoading = false;
        });
    },
    // 跳转首页
    handleJumpIndex() {
      window.open(
        'https://www.rainbond.com/docs/use-manual/app-store-manage/share-app'
      );
    },
    // 切换应用列表布局
    handleChangeType(type) {
      const sortType = document.getElementsByClassName('typeSvg');
      if (type === 'one') {
        sortType[0].classList.add('activeType');
        sortType[1].classList.remove('activeType');
        this.sortTypeStatus = true;
        this.getAppList();
      } else {
        sortType[1].classList.add('activeType');
        sortType[0].classList.remove('activeType');
        this.sortTypeStatus = false;
        this.getAppList();
      }
    },
    // 切换应用列表排序

    postAccessInfo() {
      postAccessInfo({
        marketID: this.marketInfo.marketID
      }).catch(() => { });
    },
    // 商店信息
    getStoreInfo() {
      getMarketBaseInfoApi({
        marketId: this.marketId
      })
        .then((res) => {
          window.sessionStorage.setItem(
            'storeDomain',
            JSON.stringify(res.domain)
          );
          const info = JSON.parse(window.sessionStorage.getItem('history'))
          this.marketInfo = res;
          this.postAccessInfo();
          this.getCategoryList();
          this.getAppList();
          this.getTagsList();
          setWebInfo('AI智能体市场');
        })
        .catch((re) => {
          // market is not exist, redirect to default market index
          if (re.code == 404 || re.code == 10011) {
            this.$router.push({
              name: 'appstore',
              params: {
                marketID: this.defaultMarketDomain
              }
            });
          } else if (re.code == 10019) {
            this.marketClosed = true;
          }
        });
    },
    // 传递搜索关键字
    queryChange(name, type = 'list') {
      this.searchQuery = name || '';
      this.page = 1;
      this.appType = '';
      this.subMenuColor = '';
      this.getAppList();
      if (type === 'detail') {
        this.type = name;
      }
    },
    // 切换排序
    handleSortChange(type) {
      this.getAppList(type);
    },
    // 应用列表
    getAppList(type = 'createTime', timer = '1', used = '1') {
      if (type == 'usedCount') {
        var params = {
          marketId: this.marketId,
          page: this.page,
          pageSize: this.pageSize,
          usedSort: '1'
        };
      } else if (type == 'updateTime') {
        // eslint-disable-next-line no-redeclare
        var params = {
          marketId: this.marketId,
          page: this.page,
          pageSize: this.pageSize,
          timeSort: '1'
        };
      } else {
        var params = {
          marketId: this.marketId,
          page: this.page,
          pageSize: this.pageSize
        };
      }
      this.appLoading = true;
      this.value1.length && (params.tags = this.value1.join());
      this.value2.length && (params.arch = this.value2.join());
      this.value3.length && (params.templateType = this.value3.join());
      (this.appType || this.subMenuColor) &&
        (params.apptype = this.appType || this.subMenuColor);
      this.searchQuery && (params.query = this.searchQuery);
      getAppListApi(params)
        .then((res) => {
          this.appList = res.apps || [];
          this.pageTotal = res.total;
          this.appLoading = false;
        })
        .catch(() => {
          this.appLoading = false;
        });
    },
    // 产品分类
    getCategoryList() {
      getCategoryListApi({
        marketId: this.marketId
      })
        .then((res) => {
          this.categoryList = res.tree || [];
          this.productLoading = false;
        })
        .catch(() => {
          this.productLoading = false;
        });
    },
    // 获取标签分类
    getTagsList() {
      getTagsListApi({
        marketId: this.marketId
      })
        .then((res) => {
          this.tagsList = res.tags || [];
          this.tagLoading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.tagLoading = false;
        });
    },
    // 切换标签
    handleChangeTag() {
      this.searchQuery = ''
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // 使用平滑滚动效果
      });
      this.getAppList();
    },
    // 应用详情
    viewAppDetail(item) {
      this.HistoricalInfo.tag = this.value1
      this.HistoricalInfo.arch = this.value2
      this.HistoricalInfo.temp = this.value3
      this.HistoricalInfo.sort.subMenuColor = this.subMenuColor
      window.sessionStorage.setItem('history', JSON.stringify(this.HistoricalInfo))
      this.$router.push({ path: `/marketplace/apps/${item.appKeyID}` });
    },
    // 切换产品分类
    handleChangeCategory(item, type, index) {
      if (this.HistoricalInfo.sort.item == item) {
        this.HistoricalInfo.sort.item = ''
        this.HistoricalInfo.sort.type = ''
      } else {
        this.HistoricalInfo.sort.item = item
        this.HistoricalInfo.sort.type = type
      }
      this.page = 1;
      this.searchQuery = ''
      this.type = ''
      // 点击三级
      if (type === 'item') {
        if (this.appType == item.appClassificationID) {
          this.appType = '';
          this.subMenuColor = '';
        } else {
          this.appType = item.appClassificationID;
        }
      } else {
        // 点击二级菜单
        this.appType = '';
        if (this.subMenuColor == item.appClassificationID) {
          this.subMenuColor = '';
        } else {
          this.subMenuColor = item.appClassificationID;
        }
      }
      this.value1 = [];
      this.getAppList();
    },

    // 切换页
    changePage(page) {
      this.page = page;
      this.getAppList();
    },

    // 选择cpu架构
    handleCpuArchType(type, bool) {
      this.searchQuery = ''
      this.type = ''
      this.getAppList();
    },
    // 选择应用模版类型
    changeAppTypeValue(value) {
      this.searchQuery = ''
      this.type = ''
      this.getAppList();
    },
    timmer(date) {
      return fetchdayTimes(date);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
@import 'src/styles/appStore.scss';
.backtop{
  position: fixed;
  bottom: 100px;
  right: 14px;
  z-index: 999;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  cursor: pointer;
}
.wechart {
    width: 140px;
    height: 140px;
  }
.CloseMarket {
  background: #fff;
  min-height: calc(100vh - 114px);
}

.app_pagination {
  text-align: right;
  margin-top: 20px;

  .btn-prev,
  .btn-next,
  .el-pager li {
    width: 30px;
    height: 30px;
    border: 1px solid #d9d9d9;
    margin-right: 4px;
    padding: 0;
    min-width: 30px;
    line-height: 30px;
    color: rgba(0, 0, 0, 0.65);
  }

  .el-pager li.active {
    background-color: #1890ff;
    color: #fff;
  }
}

// 轮播图
.banner {
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 16px;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
  }
}

.app_template_type {
  width: 100%;
  display: flex;
  height: 70px;
  align-items: center;

  .ram_type,
  .helm_type {
    width: 200px;
    line-height: inherit;
    white-space: normal;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 48px;
    padding-left: 0.3125em;
    padding-right: 0.3125em;
    background: linear-gradient(45deg, #f1f1f1 0%, #f7f7f7 100%);
    box-shadow: 0 12px 10px -7px rgba(0, 0, 0, 0.2);
    font-size: 1.1875em;
    font-weight: bold;
    cursor: pointer;
  }

  .ram_type {
    border-top: 3px solid #00437b;
  }

  .helm_type {
    margin-left: 4%;
    border-top: 3px solid #1598cb;
  }

  .ram_active {
    background: #00437b;
    color: #fff;
  }

  .helm_active {
    background: #1598cb;
    color: #fff;
  }

  .ram_type:hover {
    background: #00437b;
    color: #fff;
  }

  .helm_type:hover {
    background: #1598cb;
    color: #fff;
  }
}

.sort_title {
  display: flex;
  margin-top: 10px;
  height: 60px;
  align-items: center;

  h2 {
    width: 14%;
    color: #323130;
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 0;
  }

  // 排序
  .app_sort {
    width: 100%;
    background-color: #ffffff;
    display: flex;

    padding-right: 13px;
    align-items: center;
    justify-content: space-between;

    .sort_list {
      display: flex;

      .sort_title_text {
        font-size: 14px;
        font-weight: 700;
        color: rgb(17, 17, 17);
      }

      &>span {
        margin-right: 16px;
        cursor: pointer;
      }

      &>span:nth-child(1) {
        margin-right: 0px;
        width: 46px;
        cursor: default;
        display: flex;
        align-items: center;
      }

      .sort_type {
        display: flex;
        align-items: center;
        margin-left: 20px;

        span {
          width: 70px;
        }

        &>div {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .typeSvg {
          margin-right: 5px;
          cursor: pointer;
        }
      }
    }
  }
}

.active {
  color: #456fe2;
}

// 应用模版分类
.template_type {
  display: flex;
  height: 90px;

  >div {
    width: 200px;
    height: 80px;
    margin-right: 30px;

    >p {
      color: #565656;
      font-family: Segoe UI;
      font-size: 14px;
      font-weight: 400;
      line-height: 16px;
      padding-bottom: 10px;
      margin: 0px;
    }

    >div {}
  }
}

.el-icon-arrow-down,
.el-icon-arrow-up {
  font-weight: 800 !important;
}

.activeType path {
  fill: #456fe2 !important;
}

// 左侧产品分类菜单
.product_one_side,
.tag_one_side {
  display: flex;
  align-items: center;

  .product_one_icon,
  .tag_one_icon {
    margin-right: 5px;
  }
}

.product_one_title,
.tag_one_title {
  padding-left: 0px;
  font-size: 14px;
  margin-bottom: 10px;
  font-weight: 700;
  width: 100%;
  color: #000;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: 'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI',
    -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif;
}

.product_two_side {
  display: flex;
  align-items: center;

  // justify-content: space-between;
  .product_two_icon {
    margin-right: 7px;
  }

  .product_two_title {
    font-size: 13px;
    color: inherit;
    font-family: Segoe UI;
    font-weight: 400;
  }

  .product_two_count span {
    display: inline-block;
    margin-left: 2px;
    font-size: 12px;
    text-align: center;
    line-height: 16px;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    background-color: #e6eff8;
  }
}

.ant-menu-inline .ant-menu-item::after {
  border: 0 !important;
}

.ant-menu-submenu-title {
  padding: 0px !important;
  margin: 0px !important;
  height: 30px !important;
  line-height: 30px !important;
}

#checkbox_style {
  padding-left: 0px !important;
  margin: 10px 0;
  display: flex;
  flex-direction: column;

  .ant-checkbox-group-item {
    margin-bottom: 10px !important;
  }
}

.ant-menu-submenu-title:hover,
.ant-menu-item:hover {
  // background-color: #e9f6fe;
}

.ant-menu-submenu-arrow {
  display: none;
}

.product_three_side {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 12px;
  height: 34px;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;

  div {
    font-size: 12px;
  }

  .product_three_count span {
    display: inline-block;
    text-align: center;
    line-height: 20px;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background-color: #e6eff8;
  }
}


// 分隔线
.line {
  padding-right: 15px;
  margin: 12px 0px;

  div {
    height: 1px;
    background-color: #d8d8d8;
  }
}

// 标签的分类
.ant-checkbox-wrapper {
  font-size: 14px;
  color: #54585a;
}

// 去掉边框
.ant-menu-inline {
  border-right: none !important;
}

// app分割线
.app_line {
  height: 1px;
  background-color: #faf4f4;
  margin: 12px 0px;
}

.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: #fff;
  color: #54585a;
}

// subMenu的背景色
.product_submenu>.el-submenu__title {
  // background-color: #e6f7ff !important;
}

.product_submenu>.el-submenu__title .product_two_side .product_two_title {
  color: #1890ff !important;
}

.menuItem{
  cursor: pointer;
  height: 34px;
  line-height: 34px;
}
.menuItem:hover{
  font-family: PingFangSC-Regular,PingFang SC;
  font-weight: 600;
  color: #528dcf;
  background-color: #f9fafc;
}
// MenuItem的菜单背景色
.activeItem{
  background-color: #edf6ff;
}

.ant-menu-sub.ant-menu-inline>.ant-menu-item {
  padding-left: 28px !important;
  height: 20px !important;
  line-height: 20px !important;
}

.ant-menu-sub.ant-menu-inline>.ant-menu-submenu>.ant-menu-submenu-title {
  padding-left: 0 !important;
  height: 24px !important;
  line-height: 24px !important;
}

.tag_kind_menu {
  margin-top: 20px;
}

</style>
<style lang="scss" scoped>
.appstore_main {
  .container_main {
    width: 90%;
    min-height: 80vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/appstore/index.vue